"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = closeResponse;
const log_1 = require("../log");
const log = (0, log_1.getLog)(module);
/**
 * This function cleans up the response body so as not to leave connections hanging during server-side fetches.
 * @see https://github.com/nodejs/undici?tab=readme-ov-file#garbage-collection
 *
 * @param response a Fetch response
 */
function closeResponse(response) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, e_1, _b, _c;
        if (typeof window === 'undefined' && response && response.body && !response.bodyUsed) {
            try {
                const bodyReadable = response.body;
                try {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    for (var _d = true, bodyReadable_1 = __asyncValues(bodyReadable), bodyReadable_1_1; bodyReadable_1_1 = yield bodyReadable_1.next(), _a = bodyReadable_1_1.done, !_a; _d = true) {
                        _c = bodyReadable_1_1.value;
                        _d = false;
                        const chunk = _c;
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (!_d && !_a && (_b = bodyReadable_1.return)) yield _b.call(bodyReadable_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            catch (error) {
                log.error(error, 'Unable to consume response body');
            }
        }
    });
}
//# sourceMappingURL=closeResponse.js.map